var _line, _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.1748,
    y1: 41.2388,
    x2: 64.8255,
    y2: 41.2388,
    stroke: "white",
    strokeWidth: 3.81929
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5753 41.239C45.2427 31.5635 40.6595 23.2035 40.6595 20.2329",
    stroke: "white",
    strokeWidth: 3.81929
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5753 41.2393C45.2427 47.8594 40.6595 56.3042 40.6595 59.6991",
    stroke: "white",
    strokeWidth: 3.81929
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5291,
    y: 2.5291,
    width: 74.9418,
    height: 74.8734,
    rx: 37.4367,
    stroke: "white",
    strokeWidth: 5.05821
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.989f8a03e50791ca4d61407937a0233c.svg";
export { ForwardRef as ReactComponent };